import { useState } from 'react';
import { useAuth } from '../../../shared/context/AuthContext';
import { useApiError } from '../../../shared/hooks/useApiError';
import authService from '../services/authService';
import { useToast } from '../../../shared/context/ToastContext';

export function useGoogleLogin() {
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const { showError } = useToast();
  
  // Los mensajes por defecto son suficientes
  const { handleError } = useApiError({
    notificationStrategy: {
      showError: showError,
    },
  });

  const handleGoogleLogin = async (credential: string) => {
    setIsLoading(true);

    try {
      const response = await authService.googleLogin(credential);
      
      // Guarda token y usuario en el contexto
      login(response.token, response.user);
    } catch (err) {
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { googleLogin: handleGoogleLogin, isLoading };
}
